import { render } from "./CalendarioInput.vue?vue&type=template&id=018c3e12&ts=true"
import script from "./CalendarioInput.vue?vue&type=script&lang=ts"
export * from "./CalendarioInput.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__